import { Flex } from '@kvdbil/components';
import styled from 'styled-components';

export const StyledCheckboxContainer = styled(Flex)`
  position: relative;
`;
